import React from 'react'
import { Link, Slice } from 'gatsby'
import CookieConsent from 'react-cookie-consent'
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies'

const Layout = ({ children, location }) => {
  return (
    <div className='antialiased flex flex-col min-h-screen text-gray-900 bg-gray-100 dark:bg-gray-800 dark:text-gray-50'>
      <a href='#main' className='sr-only focus:not-sr-only'>
        Skip to main content
      </a>
      <Slice alias='header' />
      <main role='main' id='main'>
        {children}
      </main>
      <Slice alias='footer' />
      <CookieConsent
        location='bottom'
        buttonText='Accept'
        declineButtonText='Decline'
        disableStyles
        buttonClasses='button button-brand text-white'
        declineButtonClasses='mx-1 px-4 py-2 inline-block'
        containerClasses='absolute max-w-lg right-0 bottom-0 bg-white flex flex-col gap-4 text-lg lg:text-xl p-3 p-8 m-4 md:m-8 text-center text-lg text-brandBlue rounded z-50'
        contentClasses='inline-block mb-2'
        enableDeclineButton
        cookieName='gatsby-gdpr-google-tagmanager'
        onAccept={() => {
          initializeAndTrack(location)
        }}
        overlay='true'
        overlayClasses='fixed inset-0 bg-black/60 z-40'>
        The Juniper Studio uses cookies to improve their digital experience. For more information please view our{' '}
        <Link to='/privacy' className='underline'>
          Privacy policy
        </Link>
      </CookieConsent>
      <svg width='0' height='0'>
        <filter id='blur-and-scale' y='-50%' x='-50%' width='200%' height='200%'>
          <feGaussianBlur in='SourceGraphic' stdDeviation='50' result='blurred' />
          <feColorMatrix type='saturate' in='blurred' values='3' />
          <feComposite in='SourceGraphic' operator='over' />
        </filter>
      </svg>
    </div>
  )
}

export default Layout
